import { Chip, CircularProgress, useTheme } from '@material-ui/core'
import { constants, useTranslation, useServices } from 'cng-web-lib'
import ConveyanceApiUrls from 'src/apiUrls/ConveyanceApiUrls'
import React, { useContext, useRef, useState } from 'react'
import ConveyanceKeys from 'src/constants/locale/key/Conveyance'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment'
import { generatePath } from 'react-router-dom'
import { getStatusMetadata } from '../../../common/NACommon';
import { FileForUserGetPartyId,FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import pathMap from '../../../paths/pathMap'
import Table from '../../../components/aciacehighway/Table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LookupsContext } from '../../../contexts/LookupsContext'
import AlertDialog from '../../../components/aciacehighway/AlertDialog'
import _ from 'lodash'

const {
  filter: { BETWEEN, EQUAL, LIKE, IN }
} = constants

function TablePage(props) {
  const { history, showNotification } = props

   const { createRecord, deleteRecord, securedSendRequest } = useServices()
   const [isSubmitting, setIsSubmitting] = useState(false)
   const [submitDialog, setSubmitDialog] = useState({
     open: false,
     data: []
   })
   const [confirmDialog, setConfirmDialog] = useState({
     open: false,
     data: []
   })
   const { getLookupValue } = useContext(LookupsContext)

  const { translate } = useTranslation(Namespace.CONVEYANCE)
  const translatedTextsObject = makeTranslatedTextsObject()
  const tableRef = useRef()
  const theme = useTheme()

  function makeTranslatedTextsObject() {
    let messageFunction = translate(
      Namespace.CONVEYANCE,
      ConveyanceKeys.MESSAGE_FUNCTION
    )
    let conveyanceRefNo = translate(
      Namespace.CONVEYANCE,
      ConveyanceKeys.CONVEYANCE_REF_NO
    )
    let carrierCode = translate(
      Namespace.CONVEYANCE,
      ConveyanceKeys.CARRIER_CODE
    )
    let flightNo = translate(
      Namespace.CONVEYANCE,
      ConveyanceKeys.FLIGHT_NO
    )
    let createdDate = translate(
      Namespace.CONVEYANCE,
      ConveyanceKeys.CREATED_DATE
    )
    let updatedDate = translate(
      Namespace.CONVEYANCE,
      ConveyanceKeys.UPDATED_DATE
    )
    let status = translate(
      Namespace.CONVEYANCE,
      ConveyanceKeys.STATUS
    )
    let departurePort = translate(
      Namespace.CONVEYANCE,
      ConveyanceKeys.DEPARTURE_PORT
    )
    let arrivalPort = translate(
      Namespace.CONVEYANCE,
      ConveyanceKeys.ARRIVAL_PORT
    )
    let templateName = translate(
      Namespace.CONVEYANCE,
      ConveyanceKeys.TEMPLATE_NAME
    )
    let editSentRecords = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.EDIT_SENT_RECORDS
    )
    let editButton = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.EDIT_BUTTON
    )
    let cloneButton = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.CLONE_BUTTON
    )
    let deleteButton = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.DELETE_BUTTON
    )
    let cancelButton = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.CANCEL_BUTTON
    )
    let submitButton = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.SUBMIT_BUTTON
    )
    let deleteMultipleRecords = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.DELETE_MULTIPLE_RECORDS
    )
    let submitSentRecord = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.SUBMIT_SENT_RECORD
    )
    let submitSuccessMsg = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.SUBMIT_SUCCESS_MSG
    )
    let submitErrorMsg = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.SUBMIT_ERROR_MSG
    )
    let submitRecordDialogContent = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.SUBMIT_RECORD_DIALOG_CONTENT
    )
    let submitRecord = translate(
      Namespace.ACI_AIR,
      ConveyanceKeys.SUBMIT_RECORD
    )

    return {
      messageFunction,
      conveyanceRefNo,
      carrierCode,
      flightNo,
      createdDate,
      updatedDate,
      status,
      departurePort,
      arrivalPort,
      templateName,
      editSentRecords,
      editButton,
      cloneButton,
      cancelButton,
      submitButton,
      deleteButton,
      deleteMultipleRecords,
      submitSentRecord,
      submitSuccessMsg,
      submitErrorMsg,
      submitRecordDialogContent,
      submitRecord
    }
  }

  const columns = [
    {
      field: "conveyanceRefNo",
      sortKey: 'conveyanceRefNo',
      title: translatedTextsObject.conveyanceRefNo,
    },
    {
      field: "carrierCode",
      sortKey: 'carrierCode',
      title: translatedTextsObject.carrierCode,
    },
    {
      field: "flightNo",
      sortKey: 'flightNo',
      title: translatedTextsObject.flightNo,
    },
    {
      field: "departurePort",
      sortKey: 'departurePort',
      title: translatedTextsObject.departurePort,
      render: (rowData) =>
        getLookupValue('airport', rowData.departurePort)
    },
    {
      field: "arrivalPort",
      sortKey: 'arrivalPort',
      title: translatedTextsObject.arrivalPort,
      render: (rowData) =>
        getLookupValue('airport', rowData.arrivalPort)
    },
    {
      field: "createdDate",
      sortKey: 'createdDate',
      title: translatedTextsObject.createdDate,
      render: (rowData) =>
        rowData.createdDate && moment(rowData.createdDate).format('D MMM YYYY')
    },
    {
      field: "updatedDate",
      sortKey: 'updatedDate',
      title: translatedTextsObject.updatedDate,
      render: (rowData) =>
        rowData.updatedDate && moment(rowData.updatedDate).format('D MMM YYYY')
    },
    {
      field: "templateName",
      sortKey: 'templateName',
      title: translatedTextsObject.templateName,
    },
    {
      field: "messageFunction",
      sortKey: 'messageFunction',
      title: translatedTextsObject.messageFunction,
      render: (rowData) =>
        getLookupValue('messageFunction', rowData.messageFunction)
    },
    {
      field: "hdrStatus",
      title: translatedTextsObject.status,
      render: (rowData) => {
        const status = getStatusMetadata(rowData.hdrStatus)

        return (
          <Chip
            label={status.label}
            size='small'
            style={{
              backgroundColor: status.color,
              color: status.contrastColor
            }}
          />
        )
      }
    }
  ]

  const filters = [
    {
      label: translatedTextsObject.conveyanceRefNo,
      type: 'textfield',
      name: 'conveyanceRefNo',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.carrierCode,
      type: 'textfield',
      name: 'carrierCode',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.flightNo,
      type: 'textfield',
      name: 'flightNo',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.departurePort,
      type: 'textfield',
      name: 'departurePort',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.arrivalPort,
      type: 'textfield',
      name: 'arrivalPort',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.createdDate,
      type: 'daterange',
      name: 'createdDate',
      operatorType: BETWEEN
    },
    {
      label: translatedTextsObject.updatedDate,
      type: 'daterange',
      name: 'updatedDate',
      operatorType: BETWEEN
    },
    {
      label: translatedTextsObject.templateName,
      type: 'textfield',
      name: 'templateName',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.messageFunction,
      type: 'checkbox',
      name: 'messageFunction',
      operatorType: IN,
      options: [
        { label: 'Original', value: 'original', filterValue: { value: '9' } },
        { label: 'Change', value: 'change', filterValue: { value: '4' } },
        { label: 'Cancel', value: 'cancel', filterValue: { value: '1' } },
      ]
    },
    {
      label: translatedTextsObject.status,
      type: 'checkbox',
      name: 'hdrStatus',
      operatorType: IN,
      options: [
        { label: 'CBSA Recieved and Processing', value: 'processing', filterValue: { value: '1' } },
        { label: 'Send Successfully', value: 'sent', filterValue: { value: '1048' } },
        { label: 'Send Failed', value: 'send_failed', filterValue: { value: '1049' } },
        { label: 'Accepted', value: 'accepted', filterValue: { value: '1000' } },
        { label: 'Rejected', value: 'rejected', filterValue: { value: '1001' } },
        { label: 'Cancel Accepted', value: 'cancelled', filterValue: { value: '1003' } },
        { label: 'Cancel Rejected', value: 'cancel_rejected', filterValue: { value: '1004' } },
        { label: 'Draft', value: 'draft', filterValue: { value: '1005' } },
        { label: 'Functional Acknowledgement Message Received', value: 'func_received', filterValue: { value: '17' } },
        { label: 'Conveyance Arrived', value: 'arrived', filterValue: { value: '200' } },
        { label: 'Risk Assessment', value: 'risk_assessment', filterValue: { value: '25' } },
        { label: 'Reject Type', value: 'reject_type', filterValue: { value: '14' } },
        { label: 'Batch Error', value: 'batch_error', filterValue: { value: '28' } },
        { label: 'Data Error', value: 'data_error', filterValue: { value: '29' } },
        { label: 'Admin Error', value: 'admin_error', filterValue: { value: '20' } },
        { label: 'Enforce Error', value: 'enforce_error', filterValue: { value: '21' } },
        { label: 'Syntax Error', value: 'syntax_error', filterValue: { value: '22' } },
        { label: 'Supplementary Match Yes', value: 'supp_yes', filterValue: { value: '32' } },
        { label: 'Supplementary Match No', value: 'supp_no', filterValue: { value: '33' } }
      ]
    }
  ]

  function handleCloneConveyance(rowData) {
    createRecord.execute(
      ConveyanceApiUrls.CLONE,
      rowData,
      (data) => history.push(pathMap.CONVEYANCE_ADD_VIEW, data),
      (error) => console.log(error)
    )
  }

  function handleDeleteConveyances() {
    if (_.isEmpty(confirmDialog.data)) return

    deleteRecord.execute(
      ConveyanceApiUrls.DELETE_ALL,
      confirmDialog.data,
      () => {
        showNotification('success', 'Delete succeeded')

        if (tableRef.current?.performRefresh) {
          tableRef.current.performRefresh()
        }
      },
      (error) => console.error(error),
      () => setConfirmDialog({ open: false, data: [] })
    )
  }

  function handleSubmitConveyances() {
    if (_.isEmpty(submitDialog.data)) return

    let conveyances = [...submitDialog.data]
    const fileForUserDetails = FileForUserGetUserDetails()

    if (fileForUserDetails) {
      conveyances.forEach((conveyance) => {
        conveyance['fileForUserId'] = fileForUserDetails.fileForUserId
        conveyance['fileForUserPartyId'] = fileForUserDetails.fileForUserPartyId
        conveyance['fileForUserLoginId'] = fileForUserDetails.fileForUserLoginId
      })
    }

    setIsSubmitting(true)

    if (tableRef.current?.setLoading) {
      tableRef.current.setLoading(true)
    }

    securedSendRequest.execute(
      'POST',
      ConveyanceApiUrls.SUBMIT_ALL,
      conveyances,
      (response) => {
        if (response.status == 200) {
          const { errorMessages } = response.data

          if (!errorMessages || errorMessages.length == 0) {
            showNotification('success', translatedTextsObject.submitSuccessMsg)

            if (tableRef.current?.performRefresh) {
              tableRef.current.performRefresh()
            }
          } else {
            showNotification('error', errorMessages)
          }
        } else showNotification('error', translatedTextsObject.submitErrorMsg)
      },
      () => showNotification('error', translatedTextsObject.submitErrorMsg),
      () => {
        setIsSubmitting(false)
        setSubmitDialog({ open: false, data: [] })

        if (tableRef.current?.setLoading) {
          tableRef.current.setLoading(false)
        }
      }
    )
  }

  function shouldDisableSubmitButton(status) {
    return status === 1048 || status === 1
  }

  return (
    <>
      <Table
        actions={[
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(pathMap.CONVEYANCE_ADD_VIEW)
            },
            label: 'Create ACVR Report'
          }
        ]}
        checkboxSelection
        columns={columns}
        compact
        exportData={{ url: ConveyanceApiUrls.EXPORT }}
        fetch={{ url: ConveyanceApiUrls.SEARCH }}
        fetchFilters={[
          { field: 'formType', operator: EQUAL, value: 187 },
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() }
        ]}
        filters={filters}
        onRowClick={(rowData) => {
          const { hdrStatus, id } = rowData

          const url = generatePath(
            hdrStatus === 1 || hdrStatus === 1048
              ? pathMap.CONVEYANCE_DETAILS_VIEW
              : pathMap.CONVEYANCE_EDIT_VIEW,
            { id }
          )

          history.push(url)
        }}
        rowActions={[
          {
            disabled: (rowData) =>
              rowData.hdrStatus === 1048 || rowData.hdrStatus === 1,
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: translatedTextsObject.editButton,
            onClick: (rowData) =>
              history.push(
                generatePath(pathMap.CONVEYANCE_EDIT_VIEW, { id: rowData.id })
              ),
            tooltip: (rowData) =>
              rowData.hdrStatus === 1048 || rowData.hdrStatus === 1
                ? translatedTextsObject.editSentRecords
                : null
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'copy']} />,
            label: translatedTextsObject.cloneButton,
            onClick: handleCloneConveyance
          },
          {
            disabled: (rowData) => rowData.hdrStatus !== 1005,
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: translatedTextsObject.deleteButton,
            onClick: (rowData) =>
              setConfirmDialog({ open: true, data: [rowData] }),
            tooltip: (rowData) =>
              rowData.hdrStatus !== 1005
                ? translatedTextsObject.deleteMultipleRecords
                : null
          }
        ]}
        selectActions={[
          {
            buttonProps: {
              color: 'secondary',
              style: {
                color: theme.palette.error.main,
                minWidth: 'auto'
              }
            },
            disabled: (rows) =>
              isSubmitting ||
              rows.some((rowData) => rowData.hdrStatus !== 1005),
            icon: isSubmitting ? (
              <CircularProgress size={16} />
            ) : (
              <FontAwesomeIcon icon={['fal', 'arrow-alt-right']} />
            ),
            label: translatedTextsObject.deleteButton,
            onClick: (rows) => setConfirmDialog({ open: true, data: rows }),
            tooltip: (rows) =>
              rows.some((rowData) => rowData.hdrStatus !== 1005)
                ? translatedTextsObject.deleteMultipleRecords
                : null
          },
          {
            buttonProps: {
              style: { minWidth: 'auto' }
            },
            disabled: (rows) =>
              isSubmitting ||
              rows.some((rowData) =>
                shouldDisableSubmitButton(rowData.hdrStatus)
              ),
            icon: isSubmitting ? (
              <CircularProgress size={16} />
            ) : (
              <FontAwesomeIcon icon={['fal', 'arrow-alt-right']} />
            ),
            label: translatedTextsObject.submitButton,
            onClick: (rows) => setSubmitDialog({ open: true, data: rows }),
            tooltip: (rows) =>
              rows.some((rowData) =>
                shouldDisableSubmitButton(rowData.hdrStatus)
              )
                ? translatedTextsObject.submitSentRecord
                : null
          }
        ]}
        showNotification={showNotification}
        sortConfig={{
          type: 'column',
          defaultField: 'createdDate',
          defaultDirection: 'DESC'
        }}
        persistSettings
        tableRef={tableRef}
      />
      <AlertDialog
        cancelLabel={translatedTextsObject.cancelButton}
        confirmLabel={translatedTextsObject.submitButton}
        loading={isSubmitting}
        open={submitDialog.open}
        onClose={() => setSubmitDialog({ open: false, data: [] })}
        onCancel={() => setSubmitDialog({ open: false, data: [] })}
        onConfirm={handleSubmitConveyances}
        title={translatedTextsObject.submitRecord}
      >
        {translatedTextsObject.submitRecordDialogContent}
      </AlertDialog>
      <AlertDialog
        cancelLabel='No, take me back'
        confirmLabel='Yes, delete'
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, data: [] })}
        onCancel={() => setConfirmDialog({ open: false, data: [] })}
        onConfirm={handleDeleteConveyances}
        title={translatedTextsObject.deleteButton}
      >
        Items that you delete can't be restored. Are you sure about this?
      </AlertDialog>
    </>
  )
}

export default TablePage
